import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FileSizePipe } from '@modules/attachments/pipes/file-size.pipe';
import { SpinnerComponent } from '@modules/shared/spinner/spinner.component';
import { ActionStatus, HttpCustomErrorCode } from '@pixacare/shared';
import { UploadingFile } from '@shared/models/attachments/uploading-file';
import { TuiButton, TuiIcon } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { FileIconComponent } from '../file-icon/file-icon.component';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'pxc-uploading-file-list',
  host: { class: 'block min-w-0' },
  imports: [FileIconComponent, SpinnerComponent, FileSizePipe, TuiButton, TuiCardLarge, TuiIcon, TranslocoDirective],
  templateUrl: './uploading-file-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadingFileListComponent {
  @Input() uploadingFiles: UploadingFile[];

  @Output() retryUpload = new EventEmitter<UploadingFile>();

  ActionStatus = ActionStatus;
  HttpCustomErrorCode = HttpCustomErrorCode;

  private readonly nonRetryableErrorCodes = new Set<HttpCustomErrorCode>([HttpCustomErrorCode.FILENAME_TOO_LONG]);

  isRetryable = (errorCode?: HttpCustomErrorCode): boolean =>
    errorCode === undefined || !this.nonRetryableErrorCodes.has(errorCode);

  retry(uploadingFile: UploadingFile): void {
    this.retryUpload.emit(uploadingFile);
  }
}
